<template>
  <md-card>
    <md-card-content class="full">
      <template v-if="loaded">
        <iframe
          v-if="url"
          :src="url"
          width="1000x"
          height="100%"
          allowtransparency
        ></iframe>
        <div v-else class="missing-title">
          <div>Missing Dashboard</div>
        </div>

      </template>
      <template v-else>

      </template>
    </md-card-content>
  </md-card>
</template>

<script>
import MetabaseApi from '../../../openapi/src/api/MetabaseApi'

const metabaseApi = new MetabaseApi();

export default {
  data() {
    return {
      url: null,
      loaded: false,
    }
  },
  mounted() {
    metabaseApi.getMetabase(
        this.$root.hotelId,
        (error, data) => {
          this.url = data.dashboard_url
          this.loaded = true;
        }
    );
  }
}
</script>
<style lang="scss" scoped>
.full {
  height: calc(100vh - 123px);
  display: block;

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
  }
}
.missing-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 18px;
}
</style>
